import axios from "axios"
import { ProfitTreeApiKey } from "../../config"

axios.interceptors.request.use((config) => {
  config.headers["X-PT-API-KEY"] = ProfitTreeApiKey
  return config
})

export default axios
